export default "__VITE_PUBLIC_ASSET__20c49eb1__"